import { Mp4Box } from "./Mp4Box.class";

export class mdia extends Mp4Box {}
